import { Link } from "react-router-dom";
import { Check, Star } from "lucide-react";

export default function PackageCard({ pkg, onSelect }) {
  const featured = pkg.featured;
  return (
    <div
      data-testid={`package-card-${pkg.slug}`}
      className={`card-lift relative rounded-2xl p-8 flex flex-col ${
        featured
          ? "bg-navy text-ivory border-2 border-gold shadow-xl"
          : "bg-white border border-border shadow-sm"
      }`}
    >
      {featured && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-white text-xs font-semibold px-4 py-1 rounded-full flex items-center gap-1">
          <Star className="w-3 h-3 fill-white" /> Most Chosen
        </div>
      )}
      <h3 className={`font-serif text-3xl mb-1 ${featured ? "text-ivory" : "text-navy"}`}>{pkg.name}</h3>
      <p className={`text-sm mb-5 ${featured ? "text-slate-300" : "text-slate-500"}`}>{pkg.tagline}</p>
      <div className="flex items-end gap-1 mb-1">
        <span className={`font-serif text-5xl ${featured ? "text-gold" : "text-navy"}`}>₹{pkg.price_inr}</span>
      </div>
      <p className={`text-xs mb-6 ${featured ? "text-slate-400" : "text-slate-400"}`}>{pkg.page_length}</p>
      <ul className="space-y-3 mb-8 flex-1">
        {pkg.features.map((f, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm">
            <Check className={`w-4 h-4 mt-0.5 shrink-0 ${featured ? "text-gold" : "text-gold-hover"}`} />
            <span className={featured ? "text-slate-200" : "text-slate-600"}>{f}</span>
          </li>
        ))}
      </ul>
      {onSelect ? (
        <button
          data-testid={`select-package-${pkg.slug}`}
          onClick={() => onSelect(pkg)}
          className={featured ? "btn-gold w-full" : "btn-primary w-full"}
        >
          Choose {pkg.name.split(" ")[0]}
        </button>
      ) : (
        <Link
          to={`/checkout?package=${pkg.slug}`}
          data-testid={`select-package-${pkg.slug}`}
          className={featured ? "btn-gold w-full" : "btn-primary w-full"}
        >
          Choose {pkg.name.split(" ")[0]}
        </Link>
      )}
    </div>
  );
}
